import {
  RECLASS_ACCOUNT_ID_KEYS,
  RECLASS_ACCOUNT_ID_KEYS_IN_POPUP_FORM,
} from './taxEntry.constants';

const areValuesDefined = (values = {}, keys = []) =>
  keys.reduce((areDefined, key) => areDefined && values[key].value, true);

const areValuesDifferent = (
  prevValues = {},
  nextValues ={},
  keys = []
) => keys.reduce((areDifferent, key) => areDifferent || (prevValues[key].value !== nextValues[key].value), false);

export const hasToValidateReclassAccountIds = (prevValues, nextValues) =>
  areValuesDifferent(prevValues, nextValues, RECLASS_ACCOUNT_ID_KEYS);

export const hasToValidateReclassAccountIdsInPopupForm = (prevValues, nextValues) =>
  areValuesDifferent(prevValues, nextValues, RECLASS_ACCOUNT_ID_KEYS_IN_POPUP_FORM);

export const validateReclassAccountId = ({
  formData: {
    fromTaxEntryAccountId,
    toTaxEntryAccountId,
    taxEntryAccountId,
  },
  areReclassAccountIdsUnique,
  setState,
  callback,
  inPopupForm,
}) => {
  const areDefined = inPopupForm
    ? areValuesDefined(
      { fromTaxEntryAccountId, taxEntryAccountId },
      RECLASS_ACCOUNT_ID_KEYS_IN_POPUP_FORM
    ) : areValuesDefined(
      { fromTaxEntryAccountId, toTaxEntryAccountId },
      RECLASS_ACCOUNT_ID_KEYS
    );

  const areUnique = inPopupForm
    ? fromTaxEntryAccountId.value !== taxEntryAccountId.value
    : fromTaxEntryAccountId.value !== toTaxEntryAccountId.value;

  if (areDefined && !areUnique && areReclassAccountIdsUnique) {
    setState(state => ({
      ...state,
      areReclassAccountIdsUnique: false,
    }), () => {
      if (callback) {
        callback();
      }
    });
  } else if (!areReclassAccountIdsUnique) {
    setState(state => ({
      ...state,
      areReclassAccountIdsUnique: true,
    }), () => {
      if (callback) {
        callback();
      }
    });
  }
};
